import { useBack, useBackMultipart } from "../http";
import { FinancialDeliveryContextDTO, FinancialDeliveryStatusDTO, FinancialDetailDTO, FinancialDocumentDTO, FinancialDocumentRowDTO,
	FinancialOverviewDTO, FinancialRemittanceUsageDTO, FinancialReviewRowDTO, FinancialSummaryDTO, FinancialSyncDTO } from "../types/FinancialDTO";

export class FinancialService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getMonths() {
		try {
			const response = await this.axiosInstance.get<string[]>('/financial/months');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os meses de faturamento`, error);
			return undefined;
		}
	}

	async getOverview(months: number) {
		try {
			const response = await this.axiosInstance.get<FinancialOverviewDTO>('/financial/overview', { params: { months } });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a visão geral do financeiro`, error);
			return undefined;
		}
	}

	async getSummary(month: string) {
		try {
			const response = await this.axiosInstance.get<FinancialSummaryDTO>('/financial/summary', { params: { month } });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os indicadores do financeiro`, error);
			return undefined;
		}
	}

	async sync(months: number) {
		const response = await this.axiosInstance.post<FinancialSyncDTO>('/financial/sync', null, { params: { months } });
		return { ...response };
	}

	async getReview(previous: string, current: string) {
		try {
			const response = await this.axiosInstance.get<FinancialReviewRowDTO[]>('/financial/review', { params: { previous, current } });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a conferência do financeiro`, error);
			return undefined;
		}
	}

	async setChecked(idConta: number, checked: boolean) {
		try {
			const response = checked
				? await this.axiosInstance.put(`/financial/checks/${idConta}`)
				: await this.axiosInstance.delete(`/financial/checks/${idConta}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível atualizar a conferência da fatura`, error);
			return undefined;
		}
	}

	async getNextSequence() {
		try {
			const response = await this.axiosInstance.get<{ sequence: number }>('/financial/remittances/next-sequence');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a próxima sequência da remessa`, error);
			return undefined;
		}
	}

	async checkRemittances(idContas: number[]) {
		try {
			const response = await this.axiosInstance.post<FinancialRemittanceUsageDTO[]>('/financial/remittances/check', { idContas });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível verificar as remessas anteriores`, error);
			return undefined;
		}
	}

	async generateRemittance(sequence: number, idContas: number[]) {
		const response = await this.axiosInstance.post<Blob>('/financial/remittances', { sequence, idContas }, { responseType: 'blob' });
		return { ...response };
	}

	async getDetail(idConta: number) {
		const response = await this.axiosInstance.get<FinancialDetailDTO>(`/financial/bills/${idConta}/detail`);
		return { ...response };
	}

	async getNominal(idConta: number) {
		const response = await this.axiosInstance.get<FinancialDetailDTO>(`/financial/bills/${idConta}/nominal`);
		return { ...response };
	}

	async getDocuments(month: string) {
		try {
			const response = await this.axiosInstance.get<FinancialDocumentRowDTO[]>('/financial/documents', { params: { month } });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os documentos das faturas`, error);
			return undefined;
		}
	}

	async uploadDocuments(idConta: number, form: FormData) {
		try {
			const response = await this.axiosInstanceMultipart.post<FinancialDocumentDTO[]>(`/financial/bills/${idConta}/documents`, form);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível anexar os documentos`, error);
			return undefined;
		}
	}

	async removeDocument(id: number) {
		const response = await this.axiosInstance.delete(`/financial/documents/${id}`);
		return { ...response };
	}

	async getDeliveryContext(idConta: number) {
		try {
			const response = await this.axiosInstance.get<FinancialDeliveryContextDTO>(`/financial/bills/${idConta}/delivery-context`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível preparar o envio da fatura`, error);
			return undefined;
		}
	}

	async deliver(idConta: number, form: FormData) {
		const response = await this.axiosInstanceMultipart.post<FinancialDeliveryStatusDTO>(`/financial/bills/${idConta}/delivery`, form);
		return { ...response };
	}
}
